import {noop, pick} from 'lodash';
import {connect} from 'react-redux';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import {expandFilter} from 'shared/actions/filters';
import {openModal} from 'shared/actions/modal';
import CollegeSearch from 'src/components/college-search/college-search';
import {TERM_NOT_OFFERED_MODAL} from 'src/components/college-search/term-not-offered-modal';
import {
  getColleges,
  initializeCollegeSearch,
  resetPage,
  updateSortBy,
} from 'src/redux/college-search/actions';
import {UserType} from 'src/types/enums';
import browserHistory from '../../../../shared/history';
import {Store} from 'src/types/store';

const mapStateToProps = (state: Store) => ({
  ...pick(state, [
    'collegeSearch',
    'filters',
    'filtersInitialized',
    'modal',
    'collegeApplicationStatuses',
    'student',
  ]),
  userType: UserType.PUBLIC,
  followCollege: () => browserHistory.push('/colleges/search/sign-up-first'),
  unfollowCollege: noop,
  getCollegeAppStatuses: noop,
  setCollegeAppStatus: noop,
  showWelcomeModal: noop,
});

export default connect(mapStateToProps, {
  initializeCollegeSearch: initializeCollegeSearch,
  getColleges,
  expandFilter,
  resetPage,
  updateSortBy,
  setNavigationAnnouncement,
  openTermNotOfferedModal: () => openModal(TERM_NOT_OFFERED_MODAL),
})(CollegeSearch);
